import React from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../styles/theme/aistheme.css";
import "../../styles/theme/sharedThemeOverride.css";
import { MainViewInstruction, changeMainView } from "../../globals/observables/main/mainViewObservable";



const GeneralButtonStyle = {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    color: "black",
    height: "35px",
    marginTop: "auto",
    marginBottom: "auto",
    width: "35px",
    backgroundColor: "gray",
    maxHeight: "35px !Important",
    maxWidth: "35px  !Important",
    minHeight: "35px !Important",
    minWidth: "35px  !Important",
    padding: "0px"
  };
  
  
  const WrapperContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: pink;
    flex-basis: 100%;
    `
  );


  
  const OutterBoxContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    background-color: lightblue;

    min-width:500px;
    min-height:500px;

    margin-left:auto;
    margin-right:auto;
    margin-top:auto;
    margin-bottom:auto;
    
    `
  );


  



interface HeaderProps{

}


function ErrorPresenter(props:HeaderProps){


   

    return (
        <WrapperContainer id="auth presenter WrapperContainer">
            
            <OutterBoxContainer id="OutterBoxContainer">
                <div>ERROR PRESENTER</div>

   
            </OutterBoxContainer>

        </WrapperContainer>
        
    )
}


export default ErrorPresenter;